/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-07-31 15:08:51
 *
 *******************************************************/
import React, { Component } from 'react';
import { Button, Popover, ActionList, Icon } from '@shopify/polaris';
import { DuplicateMinor, DropdownMinor } from '@shopify/polaris-icons';
// DONE
class PopoverCloneButton extends Component<Props> {
  state = {
    active: false
  };

  togglePopover = () => {
    this.setState(({ active }) => {
      return { active: !active };
    });
  };

  render() {
    const activator = (
      <Button size="slim" onClick={this.togglePopover}>
        <span className="clone">
          <Icon source={DuplicateMinor} />
          <Icon source={DropdownMinor} />
        </span>
      </Button>
    );

    return (
      <div className="cloneFilter">
        <Popover active={this.state.active} activator={activator} onClose={this.togglePopover}>
          <Popover.Pane>
            <ActionList
              items={[
                { content: '1', onAction: () => this.handleClone(1) },
                { content: '2', onAction: () => this.handleClone(2) },
                { content: '3', onAction: () => this.handleClone(3) },
                { content: '4', onAction: () => this.handleClone(4) },
                { content: '5', onAction: () => this.handleClone(5) }
              ]}
            />
          </Popover.Pane>
        </Popover>
      </div>
    );
  }

  handleClone(cloneTimes) {
    const { filterId, handleClone } = this.props;

    // Close popover button
    this.togglePopover();

    // Call action
    handleClone(filterId, cloneTimes);
  }
}

export default PopoverCloneButton;
